module.exports = __webpack_public_path__ + "static/media/fraqtory.45efcb44.svg";